import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewLevelComp from "./Component/ViewLevelComp"


const ViewLevel =()=>{
    return(
        <>
       
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewLevelComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewLevel